import { cloneElement, useContext } from "react";
import { Source } from "react-map-gl/mapbox-legacy";
import { CustomMapTileSource } from "../../../generated/graphql";
import { MIN_BOUNDS_ZOOM } from "../utils/viewportHook";
import { LayerContext } from ".";
import {
  getFillColorPolygonsLayer,
  getFillPatternPolygonsLayer,
  getFillPointsLayer,
  getLabelLinesLayer,
  getLabelPolygonsLayer,
  getLinesLayer,
  getOutlineClickPolygonsLayer,
  getOutlineHoverPolygonsLayer,
  getOutlinePointsLayer,
  getOutlinePolygonsLayer,
  getOutlineSelectedPointsLayer,
  getSelectedPointsLayer,
} from "./utils/customMaps";

const group = "customMaps";
export const CUSTOM_MAPS_SOURCE_ID_PREFIX = "custom-maps-";

const renderCustomMapLayers = ({
  id,
  sourceLayer,
  visibility,
  labelsVisibility,
  isObject,
}: {
  id: string;
  sourceLayer: string;
  visibility: "visible" | "none";
  labelsVisibility: "visible" | "none";
  isObject: boolean;
}) => {
  const layers = [
    getLinesLayer({ id, sourceLayer, visibility, isObject }),
    getFillPointsLayer({ id, sourceLayer, visibility }),
    getOutlinePointsLayer({ id, sourceLayer, visibility }),
    getSelectedPointsLayer({ id, sourceLayer, visibility }),
    getOutlineSelectedPointsLayer({ id, sourceLayer, visibility }),
    getFillColorPolygonsLayer({ id, sourceLayer, visibility }),
    getFillPatternPolygonsLayer({ id, sourceLayer, visibility }),
    getOutlinePolygonsLayer({ id, sourceLayer, visibility }),
    getLabelLinesLayer({ id, sourceLayer, visibility: labelsVisibility }),
    getLabelPolygonsLayer({ id, sourceLayer, visibility: labelsVisibility }),
    getOutlineClickPolygonsLayer({ id, sourceLayer, visibility }),
    getOutlineHoverPolygonsLayer({ id, sourceLayer, visibility }),
  ];
  return layers.map(layer => cloneElement(layer, { key: layer.props.id }));
};

const CustomMapLayer = ({
  id,
  sources,
  labelsVisibleOnMap,
  isObject,
}: {
  id: string;
  sources: Array<CustomMapTileSource>;
  labelsVisibleOnMap: boolean;
  isObject: boolean;
}) => {
  const { isLayerVisible } = useContext(LayerContext);

  const visibility = isLayerVisible({ group, id }) ? "visible" : "none";
  const labelsVisibility =
    isLayerVisible({ group, id }) && labelsVisibleOnMap ? "visible" : "none";

  return (
    <>
      {sources.map(source => (
        <Source
          key={source.sourceId}
          id={source.sourceId}
          {...(source.mapboxUrl ?
            { url: source.mapboxUrl }
          : {
              tiles: source.tileUrlPaths.map(
                p => `${window.env.APPLICATION_URL}${p}`,
              ),
            })}
          type="vector"
          minzoom={MIN_BOUNDS_ZOOM}
          //@ts-ignore - the TS types for mapbox gl leave a lot to be desired
          promoteId="id"
        >
          {renderCustomMapLayers({
            id: source.sourceId,
            sourceLayer: source.sourceLayer,
            visibility,
            labelsVisibility,
            isObject,
          })}
        </Source>
      ))}
    </>
  );
};

export default CustomMapLayer;
